import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  errorMessage: null
};

const EventSongDeleteSlice = createSlice({
  name: "EventSongDelete",
  initialState,
  reducers: {
    eventSongDeleteSuccess(state) {
      state.success = true;
    },
    eventSongDeleteError(state, action) {
      state.errorMessage = action.payload;
    },
    eventSongDeleteReset(state) {
      state.success = false;
      state.errorMessage = null;
    }
  },
});

export const {
  eventSongDeleteSuccess,
  eventSongDeleteError,
  eventSongDeleteReset
} = EventSongDeleteSlice.actions

export default EventSongDeleteSlice.reducer;
